import { Component, OnChanges, Input, ElementRef, ViewChild } from '@angular/core';
import { NWCMStatusMonthData, NWCMPointDef, NWCMPointData } from 'app/shared/misc-classes';
import { DataService } from 'app/shared/dataservice.service';
import { Router } from '@angular/router';

@Component({
  selector: 'nwcm-tree-compact',
  templateUrl: './nwcm-tree-compact.component.html',
  styleUrls: ['./nwcm-tree-compact.component.css']
})
export class NwcmTreeCompactComponent implements OnChanges {

  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';

  widthFactor:number = 1.0;
  heightFactor:number = 1.0;
  refDevWidth:number = 1165;
  refDevHeight:number = 630;

  @ViewChild('nwcmimg') imgElt:ElementRef;

  @Input() monthObj:Date = new Date();

  _pointArray:NWCMPointDef[] = [
    new NWCMPointDef("1", 203, 59, 17, "0", "Final FPY", ""),
    new NWCMPointDef("2", 173, 89, 17, "0", "Stagewise FPY", ""),
    new NWCMPointDef("3", 144, 114, 17, "0", "Incoming FPY", ""),
    new NWCMPointDef("4", 405, 135, 17, "0", "Review Mfg Variance", ""),
    new NWCMPointDef("5", 346, 189, 17, "0", "FPY Improvement", ""),
    new NWCMPointDef("6", 167, 230, 17, "0", "Safety stock reduction", ""),
    new NWCMPointDef("7", 142, 256, 17, "0", "Export Inventory", ""),
    new NWCMPointDef("8", 133, 293, 17, "0", "Development specific inventory", ""),
    new NWCMPointDef("9", 243, 274, 17, "0", "MRP Exceptions", ""),
    new NWCMPointDef("10", 332, 294, 17, "0", "Inventory Obsolecence", ""),
    new NWCMPointDef("11", 279, 350, 17, "0", "PO Creation to GRN cycle", ""),
    new NWCMPointDef("12", 219, 358, 17, "0", "Inventory against Forecast", ""),
    new NWCMPointDef("13", 202, 397, 17, "0", "MM Updation / Review", ""),
    new NWCMPointDef("14", 185, 431, 17, "0", "BOM Correctness", ""),
    new NWCMPointDef("15", 253, 518, 17, "0", "Supplier InCo terms", ""),
    new NWCMPointDef("16", 253, 560, 17, "0", "Supplier OTD", ""),
    new NWCMPointDef("17", 253, 599, 17, "0", "LCC Sourcing", ""),
    new NWCMPointDef("18", 627, 144, 17, "0", "Reduction in Conversion and diversion", ""),
    new NWCMPointDef("19", 662, 107, 17, "0", "FG pick up ratio", ""),
    new NWCMPointDef("20", 718, 102, 17, "0", "SO Scheduling Accuracy", ""),
    new NWCMPointDef("21", 787, 142, 17, "0", "Reduce TTPT", ""),
    new NWCMPointDef("22", 785, 239, 17, "0", "FG Waiting time Reduction", ""),
    new NWCMPointDef("23", 582, 533, 17, "0", "Trade Payable %", ""),
    new NWCMPointDef("24", 589, 448, 17, "0", "Inventory %", ""),
    new NWCMPointDef("25", 707, 383, 17, "0", "Trade Receivables %", ""),
    new NWCMPointDef("26", 768, 271, 17, "0", "Inv TurnsSpot", ""),
    new NWCMPointDef("27", 768, 293, 17, "0", "Inv Turns Avg", ""),
    new NWCMPointDef("28", 860, 282, 17, "0", "ZFOC Cost reduction", ""),
    new NWCMPointDef("29", 860, 314, 17, "0", "AOT", ""),
    new NWCMPointDef("30", 860, 349, 17, "0", "ROT", ""),
    new NWCMPointDef("31", 1020, 255, 17, "0", "PO to SO creation time", ""),
    new NWCMPointDef("32", 1020, 275, 17, "0", "SO creation to release time", ""),
    new NWCMPointDef("33", 1025, 347, 17, "0", "Customer PO C40 Cycle", ""),
    new NWCMPointDef("34", 1030, 382, 17, "0", "Unclear SO(planning)", ""),
    new NWCMPointDef("35", 1026, 418, 17, "0", "Forecast Accuracy", ""),
    new NWCMPointDef("36", 953, 457, 17, "0", "Plan V/s Actual Deviation", ""),
    new NWCMPointDef("37", 1013, 541, 17, "0", "Non Trade Receivables", ""),
    new NWCMPointDef("38", 510, 600, 17, "0", "DPO - Spot", ""),
    new NWCMPointDef("39", 780, 541, 17, "0", "DSO - Spot", ""),
    new NWCMPointDef("40", 887, 493, 17, "0", "Overdue receivables & Legal Action", "")
  ];
  
  constructor(public _dataService: DataService, private _router:Router) { }

  ngOnChanges() {
    //setTimeout(() => {
      this.loadMonthData();  
    //}, 10);
    
  }

  loadMonthData() {
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this._dataService.loadNwcmTreeStatus(this.monthObj).subscribe((_nwcmMonthData: NWCMStatusMonthData) => {
      
      this._pointArray.forEach((_tmpPointDef:NWCMPointDef)=>{
        _tmpPointDef.Status = "0";
      });
       if (_nwcmMonthData != null) {
        _nwcmMonthData.Points.forEach((_tmpNwcmPoint:NWCMPointData) => {
          this._pointArray.forEach((_tmpPointDef:NWCMPointDef)=>{
            if(_tmpNwcmPoint.KPIId == _tmpPointDef.PointId){
              _tmpPointDef.Status = _tmpNwcmPoint.KPIStatus;
            }
          });
        });
       }
      this.isLoaded = true;
      this.isLoading = false;
      this.isFailed = false;
    });
  }
  imageLoaded(evnt){
    this.redrawPoints();
    //console.log(this.imgElt.nativeElement.offsetWidth);
  }
  imageResized(evnt){
    this.redrawPoints();
    //console.log(this.imgElt.nativeElement.offsetWidth);
  }

  getNWCMPointLeft(_tmpPoint:NWCMPointDef):string{
    return _tmpPoint.getLeft(this.widthFactor);
  }

  getNWCMPointWidth(_tmpPoint:NWCMPointDef):number{
    return _tmpPoint.getWidth(this.widthFactor);
  }

  getNWCMPointTop(_tmpPoint:NWCMPointDef):string{
    return _tmpPoint.getTop(this.heightFactor);
  }

  public getPointStatusSrc(_tmpStatus):string{
    switch(_tmpStatus){
      case "0":
        return "/assets/rad-grey.png";  
      case "1":
        return "/assets/rad-green.png";  
      case "2":
        return "/assets/rad-yellow.png";  
      case "3":
        return "/assets/rad-red.png";  
    }

    return "/assets/rad-grey.png";
  }

  private redrawPoints():void{
    var _tmpImgWidth:number = this.imgElt.nativeElement.offsetWidth;
    var _tmpImgHeight:number = this.imgElt.nativeElement.offsetHeight;
    this.widthFactor =  _tmpImgWidth / this.refDevWidth;
    this.heightFactor =  _tmpImgHeight / this.refDevHeight;
  }
  treeClicked():void{
    this._router.navigate(['/nwcm-tree'])
  }
}
